import {
  FeasibilityState,
  QuestionCategoriesState,
  ScoreState,
  SurveyCreationAudienceState,
  SurveyCreationReferenceState,
  SurveyCreationState,
} from './survey-creation-state.model';

export const INITIAL_FEASIBILITY_STATE: FeasibilityState = {
  total: 0,
  quotaGroups: [],
  audience: [],
  hasQuota: false,
  loading: false,
  error: null,
};

export const INITIAL_SCORE_STATE: ScoreState = {
  scorePercentage: null,
  loading: false,
  error: null,
};

export const INITIAL_QUESTION_CATEGORIES_STATE: QuestionCategoriesState = {
  data: [],
  cachedAt: null,
  loading: false,
};

export const INITIAL_SURVEY_CREATION_AUDIENCE_STATE: SurveyCreationAudienceState =
  {
    surveyId: null,
    survey: null,
    error: null,
    metadata: { value: null, valid: false, errors: [] },
    qualifications: { value: [], valid: true, errors: [] },
    quotas: { value: [], valid: true, errors: [] },
    score: { ...INITIAL_SCORE_STATE },
    feasibility: { ...INITIAL_FEASIBILITY_STATE },
  };

export const INITIAL_SURVEY_CREATION_REFERENCE_STATE: SurveyCreationReferenceState =
  {
    qualificationsRecord: {},
    questionCategories: { ...INITIAL_QUESTION_CATEGORIES_STATE },
    questionsRecord: {},
    questionsLoadingKey: null,
  };

export const INITIAL_SURVEY_CREATION_STATE: SurveyCreationState = {
  audience: { ...INITIAL_SURVEY_CREATION_AUDIENCE_STATE },
  reference: { ...INITIAL_SURVEY_CREATION_REFERENCE_STATE },
};
